import { TcVm } from '../../core/_infrastructure/types/common';
import { TwRecintoViewModel } from '../recintos/recinto.types';

export class CultivoViewModel {
    public Id: number;
    public Identificador: string;
    public IdRecinto: number;
    public IdVariedad: number;
    public Variedad?: string;
    public Grupo?: string;
    public Forma?: string;
    public CodigoEppo?: string;
    public CodigoSigPacRecinto?: string;
    public NombreCientifico?: string;
    public NombreComun?: string; // Especie
    public SuperficieVariedad: number;
    public ProduccionEstimada: number;
    public IdUsuario: number;
    public FechaCreacion: Date;
    public FechaBaja?: Date;
    public MarkToDelete?: number;
    public Desautorizado: boolean;
    public CampaniasDesautorizado: TcVm[];
}

export class CultivoItemViewModel {
    public Id: number;
    public Identificador: string;
    public IdRecinto: number;
    public IdVariedad: number;
    public Variedad: string;
    public NombreComun: string; // Especie
    public SuperficieVariedad: number;
    public ProduccionEstimada: number;
    public IdUsuario: number;
    public FechaCreacion: Date;
    public FechaBaja?: Date;
    public Desautorizado: boolean;
}

export class TwCultivoViewModel {
    public Id: number | null;
    public Identificador: string;
    public IdRecinto: number;
    public IdVariedad: number;
    public SuperficieVariedad: number;
    public ProduccionEstimada: number;
    public IdUsuario: number;
    public FechaCreacion?: Date;
    public FechaBaja?: Date;
    public Desautorizado: boolean;
    public CampaniasDesautorizado: TcVm[];
}

export class TwRecintoCultivosViewModel extends TwRecintoViewModel {
    public TwCultivoCollection: CultivoItemViewModel[];
}
